/**
 * The template every new plan is written on, by slug — the same handle
 * `StudentActionplanService::TEMPLATE_SLUG` writes against. v1 and v2 predate
 * the two independent assessments, so a plan on either has no verdicts to show.
 */
export const ACTIONPLAN_ASSESSMENT_TEMPLATE_SLUG = "actionplan_v3";

/**
 * The template the fly-out's own layout and copy are written for. A plan on any
 * other template renders from its own rows: the template's order and wording.
 */
export const ACTIONPLAN_LAYOUT_TEMPLATE_SLUG = "actionplan_v3";
